import WidgetChooser from './WidgetChooser';

export default WidgetChooser;
